





















import Vue from 'vue';
import Component from 'vue-class-component';
import PageContainer from '@/general/component/PageContainer.vue';
import { Api } from '@/common/api/Api';
import { WorkPeriodApi } from '@/context/work_period/api/WorkPeriodApi';
import WorkPeriodRouter from '@/context/work_period/router/WorkPeriodTemplateRouter';
import { WorkPeriodFilter } from '@/context/work_period/model/WorkPeriodFilter';

@Component({
  components: {
    PageContainer
  }
})
export default class DataLoggerListContainer extends Vue {
  router: WorkPeriodRouter = WorkPeriodRouter.instance();
  api: Api = WorkPeriodApi.instance();
  filter = new WorkPeriodFilter();
  entityHeaders: Array<Record<string, unknown>> = [
    {
      text: "Nazwa",
      value: "name",
      align: "left"
    }
  ];
}
